export default     {
    prompt:"Nav Side?",
    field:"--flex-direction",
    type:"style",
    default:"20px",
    options:[
        {value:"row",text:"Left"},
        {value:"row-reverse",text:"Right"}
    ]
}